{
    "NAME": "ConfigChangeLogListLanguage",
    "ConfigChangeLogList_Column_Description": "Beschreibung",
    "ConfigChangeLogList_Column_DateTime": "Datum\/Uhrzeit",
    "ConfigChangeLogList_Column_User": "Benutzer",
    "ConfigChangeLogList_Column_Action": "Aktion",
    "ConfigChangeLogList_Column_Type": "Typ",
    "ConfigChangeLogList_Column_CME": "CME",
    "ConfigChangeLogList_Column_TelSys": "Telefonieserver",
    "ConfigChangeLogList_Column_Partition": "Partition",
    "ConfigChangeLogList_Filter_Before": "Vor",
    "ConfigChangeLogList_Filter_Actions": "Aktionen",
    "ConfigChangeLogList_Filter_EntityTypes": "Entitätstypen",
    "ConfigChangeLogList_Filter_MultiSelectedCount": "[{} ausgewählt]",
    "ConfigChangeLogList_Filter_SearchUsername": "Benutzername suchen",
    "ConfigChangeLogList_Filter_SuppressNulls": "Nullwerte unterdrücken",
    "ConfigChangeLogList_Filter_SuppressNulls_No": "NEIN",
    "ConfigChangeLogList_Filter_SuppressNulls_Yes": "Ja",
    "ConfigChangeLogList_Filter_ActionDescription_All": "[Alle]",
    "ConfigChangeLogList_Filter_ActionDescription_INSERT": "Einfügen",
    "ConfigChangeLogList_Filter_ActionDescription_UPDATE": "Aktualisieren",
    "ConfigChangeLogList_Filter_ActionDescription_DELETE": "Löschen",
    "ConfigChangeLogList_Filter_ActionDescription_LOGIN": "Login",
    "ConfigChangeLogList_Filter_ActionDescription_LOGIN_FAILED": "Fehler bei der Anmeldung",
    "ConfigChangeLogList_Filter_ActionDescription_LOGIN_AS": "Anmelden als",
    "ConfigChangeLogList_Filter_ActionDescription_SYNC_REQUESTED": "Synchronisierung angefordert",
    "ConfigChangeLogList_Filter_TypeDescription_All": "[Alle]",
    "ConfigChangeLogList_Filter_TypeDescription_ACDAgents": "ACD-Agenten",
    "ConfigChangeLogList_Filter_TypeDescription_ACDAgentsOwned": "ACD-Agenten besaßen (Mitgliedschaften)",
    "ConfigChangeLogList_Filter_TypeDescription_Devices": "Geräte",
    "ConfigChangeLogList_Filter_TypeDescription_DevicesOwned": "Geräte im Besitz (Mitgliedschaften)",
    "ConfigChangeLogList_Filter_TypeDescription_DNISAssociations": "DNIS-Vereinigungen",
    "ConfigChangeLogList_Filter_TypeDescription_Codes": "Codes",
    "ConfigChangeLogList_Filter_TypeDescription_CallRecordingIntegrations": "Integrationen zur Anrufaufzeichnung",
    "ConfigChangeLogList_Filter_TypeDescription_Partitions": "Partitionen",
    "ConfigChangeLogList_Filter_TypeDescription_TelephoneSystems": "Telefonsysteme",
    "ConfigChangeLogList_Filter_TypeDescription_Users": "Benutzer",
    "ConfigChangeLogList_Filter_TypeDescription_CRMConfiguration": "CRM-Konfiguration",
    "ConfigChangeLogList_Detail_Title": "Eintrag im Prüfprotokoll",
    "ConfigChangeLogList_Detail_SummaryColumnItem": "Artikel",
    "ConfigChangeLogList_Detail_SummaryColumnValue": "Wert",
    "ConfigChangeLogList_Detail_Field": "Feld",
    "ConfigChangeLogList_Detail_OldValue": "Alter Wert",
    "ConfigChangeLogList_Detail_NewValue": "Neuer Wert"
}